import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const FormField = ({
  pref,
  type,
  label,
  placeholder,
  name,
  value,
  step,
  required,
  errors,
  onChange
}) => (
  <div
    className={classnames("form-group", {
      "has-error": errors && errors.length > 0
    })}
  >
    {label ? (
      <label
        className="control-label word-wrap"
        htmlFor={`input${name}${pref}`}
      >
        {label}
        {required ? " *" : ""}
      </label>
    ) : null}
    <input
      id={`input${name}${pref}`}
      type={type}
      className="form-control"
      placeholder={placeholder}
      name={name}
      value={value}
      onChange={onChange}
      step={step}
      aria-label={label ? label.trim() : (placeholder || name)}
    />
    {errors ? <span className="help-block">{errors.join(", ")}</span> : null}
  </div>
);

FormField.propType = {
  pref: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  errors: PropTypes.array,
  onChange: PropTypes.func
};

FormField.defaultProps = {
  type: "text",
  required: false
};

export default FormField;
